import { useLiveQuery } from "dexie-react-hooks";
import { db, type Distraction, type FocusSession } from "@/lib/db";
import { runningSession } from "@/lib/focus";
import { localDateKey } from "@/lib/time";

/** The running focus session, null when none, undefined while loading (D56). */
export function useActiveFocus(): FocusSession | null | undefined {
	return useLiveQuery(async () => (await runningSession()) ?? null, []);
}

/** Finished sessions that started on `day`, newest first. */
export function useFocusDay(day: string): FocusSession[] | undefined {
	return useLiveQuery(async () => {
		const all = await db.focus_sessions.filter((s) => !s.deleted_at && !!s.ended_at).toArray();
		return all
			.filter((s) => localDateKey(new Date(s.started_at)) === day)
			.sort((a, b) => Date.parse(b.started_at) - Date.parse(a.started_at));
	}, [day]);
}

export function useSessionDistractions(sessionId: string): Distraction[] | undefined {
	return useLiveQuery(
		() =>
			db.distractions
				.where("focus_session_id")
				.equals(sessionId)
				.filter((d) => !d.deleted_at)
				.sortBy("occurred_at"),
		[sessionId],
	);
}
